'use strict';

import { schema } from './schema.fn';

schema.$inject = ['fieldDefinitionService', 'htmlService', 'dateUtils', '$window', 'configuration', '$translate'];
angular.module('kerp-forms.forms').factory('HB_CTR_FSM_SCHEMA', schema);
